export default {
  namespaced: true,
  operational_security: {
    title: "Operational security",
    template: {
      title: "Form Template | Form Templates",
      name: "Name",
      question: "Question | Questions",
      add_new_field: "Add a New Field",
      type_response: "Response Type",
      field_name: "Field Name",
      field_types: "Field Types",
      field_type_config: "Field Type Configuration",
      options: "Options",
      option_name: "Option Name",
      add_option: "Add an Option",
      added_options: "Added Options",
      add_section: "Add section",
      new_section: "New section",
      section_name: "Section name",
      no_section: "No section",
      add_field_here: "Add question",
      confirm_delete_section:
        "Delete the section? Its questions will be moved to 'No section'.",
      confirm_delete_field: "Delete this question?",
      is_group: "Multiple"
    },
    evaluation: {
      title: "Form answer | Form answers",
      new_evaluation: "Answer form",
      edit_evaluation: "Edit form answers",
      command_executed: "Command executed",
      command_queued: "Command queued",
      command_running: "Executing command",
      command_succeeded: "Command executed successfully",
      command_failed: "Command execution failed",
      command_retry: "Retry",
      command_check_result: "Check result",
      command_tracking_error: "The command execution could not be started or confirmed.",
      command_tracking_timeout: "The execution is still unconfirmed. Check the same attempt again.",
      command_retry_title: "Retry command",
      command_retry_warning: "The previous attempt may have completed partially. Do you want to execute the command again?",
      select_form: "Select the operational security form",
      form_start_at: "Start date",
      form_end_at: "End date",
      sent_to: "Sent to",
      shortcuts: "Shortcuts",
      status: {
        in_progress: "In Progress",
        pending: "Pending",
        review: "Under Review",
        completed: "Completed",
        rejected: "Rejected",
        reopened: "Reasigned",
        in_review: "In review",
        approved: "Approved",
        canceled: "Canceled",
        commented: "Commented",
        updated: "Updated"
      },
      email_preview: "Email preview",
      validation_comments: "Validation comments",
      reopened_comments: "Reopened form comments",
      create_sitrep: "Create SITREP",
      create_newsletter: "Create newsletter",
      create_news_flash: "Create ⁠⁠news flash",
      create_informative_email: "Create informative email",
      send_form: "Send form",
      error_send_form: "Error Sending form",
      success_send_form: "Form successfully submitted",
      answers_successfully: "Answers successfully saved",
      answers_error: "Error saving answers",
      reload: "Reload",
      review_successfully: "Successfully sent for review",
      review_error: "Error sending form for review",
      status_successfully: "Status successfully updated",
      status_error: "Error updating status",
      reopen_successfully: "Form successfully reopened",
      reopen_error: "Error on reopen form",
      related_forms: "Related Forms",
      mailable: "Mailable",
      standard: "Standard",
      loading_tracking: "Loading form tracking...",
      create: "Create",
      does_not_apply: "Does not apply"
    },
    prefill: {
      title: "Pre-Registrations",
      search: "Search by reference, SOEID, Facility",
      create: "Create Pre-Registration",
      table_tooltip: "Drag and drop a pre-registration to complete the form",
      reference: "Reference",
      facility: "Facility",
      event_type: "Event Type",
      date: "Date",
      questions: "Questions",
      another_facility: "Another Facility",
      close: "Close Pre-Registration",
      edit: "Edit Pre-Registration",
    },
    create_registration: "Create Registration",
    select_form_place_holder: "Search for and select a form",
    select_facility_to_enable_command: "Select a facility to enable the command.",
    form_id_to_enable_command: "The form must be created for enable the command.",
    crisis_form: {
      add: "Add Crisis Form",
      title: "Crisis Form",
      name: "Name",
      reference_number: "Reference number",
      responsable: "Responsible",
      unitsAdded: "Added facilities",
      addUnits: "Add Facilities",
      emptyUnits: "Empty facilities",
      risk: "Risk",
      total_employees: "Total employees",
      total_facilities: "Total facilities",
      buildings: "Buildings and outbuildings",
      cpae: "Total CPAE´s",
      cpd: "Total CPD´s",
      facilities_atm: "Total ATM´s facilities",
      third_partys_atm: "Total ATM´s third parties",
      payroll_atm: "Total ATM´s payroll",
      mobile_unit: "Unit mobile",
      mobile_unit_atm: "Total ATM´s unit mobile",
      master_data: "Master Data",
      allocations_by_region: "Allocations by region",
      allocations_by_municipality: "Allocations by municipality",
      preventive_closures: "Preventive closures",
      offline_facilities: "Offline facilities",
      facilities_with_water_filtration_systems: "Facilities with water filtration systems / ceiling drops",
      broken_glass: "Broken glass",
      damaged_cameras: "Damaged cameras",
      buildings_offline: "Buildings offline",
      buildings_with_water_leaks: "Buildings with water leaks / ceiling tiles falling",
      CPAES_offline: "CPAEs offline",
      CPAES_closures: "CPAEs closures",
      facilities_with_offline_ATMs: "Facilities with offline ATMs",
      third_party_offline_ATMs: "Third-party offline ATMs / Payroll offline",
      officials_contacted: "Officials contacted",
      support_civil_servants: "Support for civil servants",
      blocked_roads: "Blocked roads",
      total_branches: "Total branches",
      total_mobile_unit: "Total mobile unit",
      total_atm: "Total ATM´s",
      total_emergency_kits_delivered: "Total Emergency Kits Delivered",
      total_generators_delivered: "Total Generators Delivered",
      csis: "CSIS",
      csis_days_in_field: "CSIS days in field",
      csis_total_volunteers: "Total CSIS volunteers",
      loss: "Loss",
      operational: "Operational",
      total_affecting_cash: "Total affecting cash",
      cash_impact: "Cash impact",
      total: "Total",
      level: "Level",
      description: "Description",
      to_list_id: "For",
      cc_list_id: "Copy",
      bcc_list_id: "Blind copy",
      allocations_by_facility: "Allocations by facility",
      inpact_on_operations: "Impact on operations",
      complete_closure: "Complete closure",
      early_closing: "Early closing",
      late_opening: "Late opening",
      out_of_service: "Out of service",
      offline: "Offline",
      reset: "Reset",
      CCTV: "CCTV",
      water_leakage: "Water leakage and ceiling tiles falling",
      public_courtyard: "Public courtyard",
      etv_transfer_box: "ETV transfer box",
      internal_areas: "Internal areas",
      box_train: "Box train",
      atm_area: "ATM area",
      parkin: "Parking",
      broken_glass: "Broken glass",
      side_walls_or_facade: "Side walls or facade",
      main_entrance: "Main entrance",
      atm_in_operation: "ATM in operation",
      atm_damages: "ATM damages",
      broken_screen: "Broken screen",
      broken_lock: "Broken lock",
      open: "Open",
      risk_facilities: "Risk facilities",
      has_operational_backup_power: "It has a fully operational backup power system",
      backup_power_capacity: "backup power system capacity",
      diesel_level: "Diesel level",
      UPS: "UPS",
      facility_with_anticyclonic_curtain: "Facility with an anticyclonic curtain",
      facility_with_glass_facade: "Facility with a glass facade",
      facility_near_rivers: "Facility near rivers",
      metal_roof: "Metal roof",
      encased_in_solid_material: "Encased in solid material",
      at_the_mall: "At the mall",
      vacant_lots: "Vacant lots",
      employee_information_by_facility: "Employee information by facility",
      employee_name: "Employee name",
      geid: "GEID",
      employee_position: "Employee position",
      contact_number: "Contact phone number",
      emergency_number: "Emergency phone number",
      street_address_house_number: "Street address and house number",
      neighborhood: "Neighborhood",
      municipality: "Municipality",
      assigned_sirh: "Assigned SIRH",
      facility_name: "Facility name",
      status_confirmation_call_tree: "Status confirmation via call tree response",
      i_feel_fine: "I feel fine",
      by_mistake: "By mistake",
      need_help: "Need help",
      unreachable: "Unreachable",
      evacuated: "Evacuated",
      contacted_by: "Contacted by",
      ccb: "CCB",
      business: "Business",
      csis: "CSIS",
      damages_and_needs: "Damages and needs",
      flooded_home: "Flooded home",
      shortage_of_food_supplies: "Shortage of food supplies",
      emergency_plant: "Emergency plant",
      damaged_vehicle: "Damaged vehicle",
      lack_of_public_transportation: "Lack of public transportation",
      filters_by_region_city: "Filters by region, city.",
      only_rows_with_data: "Only rows with data"
    },
    operational_processes: {
      title: "External Personnel Access Control",
      folio: "Logbook ID",
      unit: "Unit",
      unit_placeholder: "Select a unit",
      category: "Category",
      state: "State",
      municipality: "Municipality",
      subregion: "Subregion",
      check_in_datetime: "Check-in date/time",
      check_out_datetime: "Check-out date/time",
      company: "Vendor",
      company_placeholder: "Select a vendor",
      employee: "Assigned technician",
      employee_placeholder: "Select a technician",
      report_number: "Ticket",
      activities: "Activities or project type",
      system: "Systems",
      is_test_mode_enabled: "Enable test mode",
      is_test_mode_enabled_placeholder: "Select",
      type_of_maintenance: "Maintenance type",
      type_of_maintenance_placeholder: "Select maintenance type",
      panel: "Panel",
      panel_placeholder: "Select the panel",
      tenant_origin: "Tenant origin",
      tenant: "Maintenance tenant",
      tenant_placeholder: "Select maintenance tenant",
      add_partial_checkout: "Add partial check-out",
      partial_checkout_check_in_datetime: "Start date/time",
      partial_checkout_check_out_datetime: "Pass-in date/time",
      partial_checkout_description: "Description",
      partial_checkout_is_systems_enabled: "Reactivate systems",
      delete: "Delete",
      generate_timestamp: "Click to generate timestamp",
      status: "Status",
      maintenance_devices: "Maintenance devices",
      sirh: "SIRH",
      rems: "REMS",
      id_seproban: "ID SEPROBAN",
      finish_maintenance: "Finish maintenance",
      maintenance: "Maintenance",
      project_implementation: "Project implementation",
      image: "Image",
      name: "Name",
      step_create: "Create",
      step_information: "Information",
      step_panel_configuration: "Panel configuration",
      type: "Type",
      user_start: "CCB Check-in",
      user_finish: "CCB Check-out",
      siren_enabled: "Siren Enabled and Tested on Check-out",
      siren_disabled: "Siren Disabled in Remote on Check-in",
      infrared_height: "Public Area Infrared Height",
      infrared_validated: "Infrared Validated",
      service_time: "Service Time",
      sector: "Region",
      panel_password: "Panel Password",
      panel_delete_password: "Panel Password Removed",
      panel_users: "Panel technician user",
      panel_users_placeholder: "Select a panel user",
      panels_empty: "No panels were found for the installation",
      panel_users_empty: "No panel technician users were found",
      panel_user_code: "User code",
      panel_user_code_placeholder: "Click to generate a code",
      technicians: "Technicians",
      devices: "Devices",
    },
    confirmGoBack: "Are you sure you want to exit?",
    confirmGoBackSubtitle: "Any unsaved changes will be lost.",
    show_horizontal_form: "Show form",
    close_horizontal_form: "Close form",
    activities: {
      title: "Activities",
      description: "Description",
    },
    security_manager_comments: "Security Manager Comments",
    save_comments: "Save Comments",
    save_comments_success: "Comment saved successfully",
    sec_manager_comments: "Comments from the security manager",
    sirh_facility_name: 'SIRH and Facility Name',
    security_monitoring: 'Security Monitoring',
    last24h: 'Last 24 hours',
    last48h: 'Last 48 hours',
    lastWeek: 'Last week',
    lastMonth: 'Last month',
    significant_event_pending_comments: 'Significant event pending comment',
    significant_event_save_success: 'Significant event saved successfully',
  },
};
